import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import "./fonts/circularStd/CircularStd-Bold.ttf";
import "./fonts/graphik/GraphikBold.otf";
import { BrowserRouter } from "react-router-dom";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import { Provider } from "react-redux";
import store from "./features/store";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);

const theme = createTheme({
  typography: {
    h1: {
      fontSize: "48px",
      lineHeight: "57px",
      letterSpacing: "-0.52px",
      fontFamily: "CircularStdBold",
      fontWeight: 700,
      marginBottom: "20px",
    },
    h3: {
      fontSize: "44px",
      lineHeight: "53px",
      letterSpacing: "-0.48px",
      fontFamily: "CircularStdBold",
      fontWeight: 700,
      marginBottom: "20px",
    },
    h5: {
      fontSize: "20px",
      lineHeight: "25px",
      letterSpacing: "-0.22px",
      fontFamily: "CircularStdBold",
      fontWeight: 700,
      marginBottom: "30px",
      paddingBottom: "10px",
      textTransform: "capitalize",
    },
    h6: {
      fontSize: "18px",
      lineHeight: "22px",
      letterSpacing: "-0.17px",
      fontFamily: "CircularStdBold",
      fontWeight: 700,
      paddingBottom: "10px",
      textTransform: "capitalize",
    },
    subtitle1: {
      fontWeight: 400,
      fontFamily: "GraphikRegular",
      padding: "2px 0",
      fontSize: "16px",
      lineHeight: "22px",
      marginBottom: "20px",
      textTransform: "capitalize",
    },
    body1: {
      fontWeight: 400,
      fontFamily: "GraphikRegular",
      fontSize: "21px",
      letterSpacing: " -0.15px",
      lineHeight: "28px",
      marginBottom: "30px",
    },
    body2: {
      fontWeight: 400,
      fontFamily: "GraphikRegular",
      fontSize: "15px",
      letterSpacing: " -0.15px",
      lineHeight: "20px",
      marginBottom: "30px",
      color: "rgb(150, 150, 150)",
    },
  },
});

root.render(
  <Provider store={store}>
    <ThemeProvider theme={theme}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </ThemeProvider>
  </Provider>
);
